import "core-js/modules/es6.array.find";

var NavBar =
/** @class */
function () {
  function NavBar(isPaste) {
    if (isPaste === void 0) {
      isPaste = true;
    }

    this.isPaste = isPaste;
    this.winDom = $(window);
    this.navWrap = $('#nav-wrap');
    this.navList = $('.nav-list');
    this.sectionModel = $('.section-model');
    this.initNavTop = this.navWrap.offset().top;
    this.initNavHeight = this.navWrap.height();
    this.init();
  }

  NavBar.prototype.init = function () {
    this.bindEvent();
  };

  NavBar.prototype.bindEvent = function () {
    var _this = this;

    this._initNavbar();

    if (this.isPaste) {
      this.winDom.on('scroll', function (e) {
        _this._paste(e);

        _this._scrollToActivate(e);
      });
    }
  }; // 初始化导航条


  NavBar.prototype._initNavbar = function () {
    var _a = this,
        winDom = _a.winDom,
        sectionModel = _a.sectionModel,
        navList = _a.navList;

    navList.on('click', 'li', function () {
      var index = $(this).index();
      var sectionModelHeight = sectionModel.eq(index).offset().top;
      var navListHeight = navList.height();
      var scrollNum = sectionModelHeight - navListHeight;
      navList.find('li').removeClass('active');
      $(this).addClass('active');
      winDom[0].scrollTo(0, scrollNum);
    });
  }; // 导航条吸顶


  NavBar.prototype._paste = function (e) {
    var scrollTop = $(e.currentTarget).scrollTop();

    if (scrollTop > this.initNavTop) {
      this.navWrap.addClass('nav-fix');
    } else {
      this.navWrap.removeClass('nav-fix');
    }
  }; // 导航条点击


  NavBar.prototype._scrollToActivate = function (e) {
    var _a = this,
        navList = _a.navList,
        initNavHeight = _a.initNavHeight;

    var H = $(e.currentTarget).scrollTop() + initNavHeight;
    this.sectionModel.each(function (index) {
      var h = $('.section-model').eq(index).offset().top;

      if (H >= h) {
        navList.find('.nav-item').removeClass('active');
        $('.nav-item').eq(index).addClass('active');
      }
    });
  };

  return NavBar;
}();

export default NavBar;